import Flowit from '../../../../services/flowit';
import * as types from './types';

export const loadList = ({ commit }) => {
  commit(types.LOAD, true);
  Flowit.recharges.list()
    .then(response => {
      commit(types.LOAD_LIST, response.data.recharges);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.LOAD, false);
      commit(types.ERROR, error.response.data.message);
    });
};

export const loadProviders = ({ commit }) => {
  commit(types.LOAD, true);
  Flowit.recharges.providers()
    .then(response => {
      commit(types.LOAD_PROVIDERS, response.data.providers);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.LOAD, false);
      commit(types.ERROR, error.response.data.message);
    });
};

export const loadProducts = ({ commit }, params) => {
  commit(types.LOAD, true);
  Flowit.recharges.products(params)
    .then(response => {
      commit(types.LOAD_PRODUCTS, response.data.products);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.LOAD, false);
      commit(types.ERROR, error.response.data.message);
    });
};

export const newRecharge = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.recharges.recharge(params)
    .then(response => {
      commit(types.NEW_RECHARGE_RESPONSE, response.data.recharge);
      commit(types.SUCCESS_STATUS, true);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.LOAD, false);
    });
};

export const getRecharge = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.recharges.show(params)
    .then(response => {
      commit(types.GET_RECHARGE, response.data.recharge);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.LOAD, false);
    });
};

export const confirmRecharge = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.recharges.confirm(params)
    .then(response => {
      commit(types.CONFIRM_RECHARGE_RESPONSE, response.data.recharge);
      commit(types.SUCCESS_STATUS, true);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.LOAD, false);
    });
};

export const cancelRecharge = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.recharges.cancel(params)
    .then(response => {
      commit(types.CANCEL_RECHARGE_RESPONSE, response.data.recharge);
      commit(types.SUCCESS_STATUS, true);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.LOAD, false);
    });
};

export const activeNew = ({ commit }, param) => {
  commit(types.ACTIVE_NEW, param);
};

export const isLoad = ({ commit }, param) => {
  commit(types.IS_LOAD, param);
};

export const showAmount = ({ commit }, param) => {
  commit(types.SHOW_AMOUNT, param);
};

export const showNumber = ({ commit }, param) => {
  commit(types.SHOW_NUMBER, param);
};

export const showSubmit = ({ commit }, param) => {
  commit(types.SHOW_SUBMIT, param);
};

export const showConfirm = ({ commit }, param) => {
  commit(types.SHOW_CONFIRM, param);
};

export const showSuccess = ({ commit }, param) => {
  commit(types.SHOW_SUCCESS, param);
};

export const showError = ({ commit }, param) => {
  commit(types.SHOW_ERROR, param);
};

export const showLoad = ({ commit }, param) => {
  commit(types.SHOW_LOAD, param);
};
